import styled from "styled-components";
import { colors } from "../../assets/colors";

export const TabsContainer = styled.section`
  .dashboard-tabs {
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    border-bottom: 1px solid ${colors["PR-001-100"]};

    ul {
      display: flex;
    }

    li {
      text-align: center;
      margin: 0 5px 0 0;
      padding: 16px 20px 16px 20px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      cursor: pointer;
      text-transform: uppercase;
      min-width: 210px;
    }
    .tab-selected {
      background: ${colors["PR-001-100"]};
    }
  
    .tab-not-selected {
      background: #f1f1f1;
      color: ${colors["primaryColor"]};
      font-weight: 400;
    }
  }
`;
